import { render, staticRenderFns } from "./courseItme.vue?vue&type=template&id=01bf66fc&scoped=true"
import script from "./courseItme.vue?vue&type=script&lang=js"
export * from "./courseItme.vue?vue&type=script&lang=js"
import style0 from "./courseItme.vue?vue&type=style&index=0&id=01bf66fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf66fc",
  null
  
)

export default component.exports